import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { MdClose } from 'react-icons/md';
import { colors } from '../../constants';
import Text from '../styled/Text';

const StyledModalWrapper = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  transition: 0.5s;
  &.active {
    opacity: 1;
    pointer-events: all;
    z-index: 10;
  }
`;

const StyledModalContent = styled.div`
  border-radius: 6px;
  background-color: white;
  transform: scale(0.5);
  transition: 0.4s all;
  &.active {
    transform: scale(1);
  }
`;

const TitleContainer = styled.div`
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px 0 16px;
  border-bottom: 1px solid ${colors.grey95};
`;

const Modal = ({ isOpen, onClose, children, title }) => {
  const handleModalClick = () => {
    onClose(false);
  };

  return (
    <>
      <StyledModalWrapper
        className={isOpen ? 'active' : ''}
        onClick={handleModalClick}>
        <StyledModalContent
          className={isOpen ? 'active' : ''}
          onClick={e => e.stopPropagation()}>
          {title && (
            <TitleContainer>
              <Text variant="title2">{title}</Text>
              <MdClose onClick={onClose} fill={colors.navy} />
            </TitleContainer>
          )}
          {children}
        </StyledModalContent>
      </StyledModalWrapper>
    </>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
};

export default Modal;
